// @flow
import * as React from 'react';
import { Modal, Button } from 'antd';
import Form from './Components/Form';
import { setProps } from './props';

type Props = {
  submitting: boolean,
  supplierItem: {},
  componentDidMount: (props: any) => void,
  onClickCancel: () => void,
  onClickSubmit: () => void,
  onClickDelete: () => void,
}

export default class extends React.PureComponent<Props> {

  componentDidMount = () => {
    setProps(this.props);
    this.props.componentDidMount(this.props);
  }

  render () {

    const {
      submitting,
      supplierItem,
      onClickCancel,
      onClickSubmit,
      onClickDelete,
    } = this.props;

    const footer = []

    if (supplierItem) footer.push(
      <Button key='delete' type='danger' onClick={onClickDelete} style={{ float: 'left' }}>
        Delete
      </Button>,
    )

    footer.push(
      <Button key='cancel' onClick={() => onClickCancel()}>
        Cancel
      </Button>,
      <Button key='save' type='primary' loading={submitting} onClick={onClickSubmit}>
        {supplierItem ? 'Update' : 'Create'}
      </Button>,
    )

    return (

      <Modal
        title={`${supplierItem ? 'Update Catalog Item': 'New Catalog Item'}`}
        visible
        footer={footer}
        onCancel={onClickCancel}
        width={800}
      >

        <Form />

      </Modal>
    )
  }
}
